import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
    const { user } = useAuth();
    const [cart, setCart] = useState({ items: [], subtotal: 0 });

    const refresh = useCallback(async () => {
        if (!user || user === false) {
            setCart({ items: [], subtotal: 0 });
            return;
        }
        try {
            const { data } = await api.get("/cart");
            const subtotal = (data.items || []).reduce((s, i) => s + (i.price || 0), 0);
            setCart({ items: data.items || [], subtotal });
        } catch {
            // ignore network/auth errors silently
        }
    }, [user]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const addItem = async (track_id, license_id) => {
        const { data } = await api.post("/cart/items", { track_id, license_id });
        setCart({ items: data.items || [], subtotal: data.subtotal || 0 });
        return data;
    };

    const removeItem = async (track_id, license_id) => {
        const { data } = await api.delete("/cart/items", { params: { track_id, license_id } });
        setCart({ items: data.items || [], subtotal: data.subtotal || 0 });
    };

    const clear = async () => {
        await api.delete("/cart");
        setCart({ items: [], subtotal: 0 });
    };

    return (
        <CartContext.Provider value={{ cart, refresh, addItem, removeItem, clear }}>
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
